import type { Row, SortOrder } from './types'

export type RowComparator = (left: Row, right: Row) => number

function score(row: Row): number {
  return row.score === null ? -1 : row.score
}

export function overdueDays(row: Row): number {
  return row.due_status === 'overdue' && row.due_days !== null ? -row.due_days : 0
}

export function dueSort(row: Row): number {
  return row.due === null ? Number.MAX_SAFE_INTEGER : Date.parse(`${row.due}T00:00:00Z`)
}

function key(left: Row, right: Row): number {
  return left.key.localeCompare(right.key)
}

export function compareRows(order: SortOrder): RowComparator {
  switch (order) {
    case 'worst':
      return (left, right) => overdueDays(right) - overdueDays(left)
        || score(right) - score(left) || (right.idle || 0) - (left.idle || 0) || key(left, right)
    case 'score':
      return (left, right) => score(right) - score(left) || overdueDays(right) - overdueDays(left) || key(left, right)
    case 'overdue':
      return (left, right) => overdueDays(right) - overdueDays(left) || score(right) - score(left) || key(left, right)
    case 'idle':
      return (left, right) => (right.idle || 0) - (left.idle || 0) || score(right) - score(left) || key(left, right)
    case 'age':
      return (left, right) => (right.age || 0) - (left.age || 0) || score(right) - score(left) || key(left, right)
    case 'due':
      return (left, right) => dueSort(left) - dueSort(right) || score(right) - score(left) || key(left, right)
    case 'slips':
      return (left, right) => right.due_slips - left.due_slips || right.due_moves - left.due_moves
        || (right.due_net_slip || 0) - (left.due_net_slip || 0) || key(left, right)
    case 'entered':
      return (left, right) => (right.entered || '').localeCompare(left.entered || '')
        || Number(left.entered_est) - Number(right.entered_est) || key(left, right)
    case 'key':
      return key
  }
}

export function sortRows(rows: Row[], order: SortOrder): Row[] {
  return rows.slice().sort(compareRows(order))
}
